// extracted by mini-css-extract-plugin
export default {"rotateText":"leftSideBoxRotateText_rotateText__vvc0T"};